<template>
  <div class="play-screen">
    <b-row class="justify-content-center h-100 mx-0 play-screen__row">
      <b-col class="px-0">
        <div
          id="fullscreen-div"
          :class="{
            'is-fullscreen': isFullscreen,
            'has-game-bg': cellcardFramePotrait,
          }"
        >
          <!-- =====================================================
               GAME IFRAME
               ===================================================== -->

          <iframe
            ref="iframe"
            src="/game/4271230733/load/"
            allow="fullscreen"
            allowfullscreen
            webkitallowfullscreen
            frameborder="0"
            class="display-frame"
            :class="{ 'display-frame--landscape': cellcardFramePotrait }"
          ></iframe>

          <!-- =====================================================
               IFRAME FALLBACK
               ===================================================== -->

          <div v-if="iframeFailed" class="iframe-fallback">
            <div class="fallback-box">
              <h4>Game failed to load in iframe</h4>

              <p>Try opening the game in a new tab or retry.</p>

              <div class="btns">
                <b-button variant="primary" @click="openInNewTab">
                  Open in new tab
                </b-button>

                <b-button variant="secondary" @click="retryIframe">
                  Retry
                </b-button>
              </div>
            </div>
          </div>

          <!-- =====================================================
               FULLSCREEN BUTTON
               ===================================================== -->

          <div
            v-if="!this.isIOS && !fullscreen && !android"
            class="fullscreen-button-wrapper"
          >
            <b-button
              @click="toggle"
              class="custom-btn"
              :aria-label="
                isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'
              "
            >
              <b-icon
                :icon="isFullscreen ? 'fullscreen-exit' : 'fullscreen'"
                size="3rem"
                style="color: rgb(0 228 255)"
              />
            </b-button>
          </div>

          <!-- =====================================================
               POPUP
               ===================================================== -->

          <PopupReward :ids="idPopup" :dataPopup="datapopup" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import PopupReward from "@/components/Popup.vue";

import {
  exitBrowserFullscreen,
  getFullscreenElement,
  requestBrowserFullscreen,
} from "@/utils/fullscreen";

import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { apiMsg } from "@/provider";

export default {
  components: {
    PopupReward,
  },

  data() {
    return {
      statusRequest: 0,

      // Native browser fullscreen
      fullscreen: false,

      // CSS fake fullscreen
      // digunakan terutama untuk iOS
      forcedFullscreen: false,

      urls: "#",

      storeData: {
        game_id: this.gameId,
        msisdn: this.$store.state.user,
        token_id: this.$store.state.tokenLife,
        data: [],
      },

      loadAjax: false,

      idPopup: null,

      datapopup: {
        image: null,

        title: null,

        description: null,

        txtButton: null,

        buttonCancel: null,

        show: false,
      },

      iframeReady: false,

      iframeFailed: false,

      iframeCheckTimer: null,

      ws: null,
      reconnectTimer: null,

      dataToken: {
        image: null,

        title: null,

        description: null,

        txtButton: null,
      },

      options: {
        title_value: "score",

        mode_game: "round",
      },
    };
  },

  computed: {
    ...mapState([
      "gameId",

      "user",

      "tokenLife",

      "popupReward",

      "popupToken",

      "popupSubscription",

      "popupLogout",

      "url",

      "reward",

      "coin",

      "profile",

      "mode",

      "android",

      "cellcardFramePotrait",

      "leaderboardList",

      "telco",

      "sessionUser",
    ]),

    ...mapGetters({
      dr: "getDR",
    }),

    // ============================================================
    // iOS DETECTION
    // ============================================================

    isIOS() {
      return (
        /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
      );
    },

    // ============================================================
    // SINGLE FULLSCREEN STATE
    // ============================================================

    isFullscreen() {
      return this.fullscreen || this.forcedFullscreen;
    },
  },

  beforeMount() {
    let _This = this;

    this.$store.state.isLoading = true;

    this.getGames().then(
      async () => {
        this.urls = this.setUrl(this.url);

        // ========================================================
        // IFRAME READY CHECK
        // ========================================================

        this.iframeReady = false;

        this.iframeFailed = false;

        if (this.iframeCheckTimer) {
          clearTimeout(this.iframeCheckTimer);
        }

        // this.iframeCheckTimer = setTimeout(() => {
        //   if (!this.iframeReady) {
        //     this.iframeFailed = true;
        //   }

        //   this.iframeCheckTimer = null;
        // }, 5000);

        this.getGameReward();
      },

      (error) => {
        this.statusRequest = 0;

        console.error("err", error);
      },
    );

    // ============================================================
    // PURCHASE CALLBACK
    // ============================================================

    window.onPurchaseSuccess = function (productID) {
      let changeKeyword = productID + "GP";

      _This.getdeliverRechives(changeKeyword);
    };
  },

  mounted() {
    // ============================================================
    // IFRAME WINDOW
    // ============================================================

    if (this.$refs.iframe) {
      this.iframeGame = this.$refs.iframe.contentWindow;
    }

    // ============================================================
    // ANDROID ORIENTATION
    // ============================================================

    if (this.android && window.androidOrientation) {
      window.androidOrientation.postMessage("landscape");
    }

    // ============================================================
    // CELL CARD ORIENTATION
    // ============================================================
    if (this.cellcardFramePotrait) {
      this.$refs.iframe.classList.add("display-frame--landscape");
    }

    this.setPopupShow(false);

    // Reconnect session websocket if the user returns with a stored session.
    // This covers closing the browser and reopening the site later.
    if (this.sessionUser) {
      this.connectSessionSocket(this.sessionUser);
    }

    const deviceAndroid = this.android;

    // ============================================================
    // MESSAGE HANDLER
    // ============================================================

    this.messageHandler = (event) => {
      // ----------------------------------------------------------
      // IFRAME READY
      // ----------------------------------------------------------

      this.iframeReady = true;

      if (this.iframeCheckTimer) {
        clearTimeout(this.iframeCheckTimer);

        this.iframeCheckTimer = null;
      }

      this.iframeFailed = false;

      const data = event.data || {};

      // ----------------------------------------------------------
      // GAME COMMANDS
      // ----------------------------------------------------------

      switch (data.cmd) {
        // ========================================================
        // POPUP HADIAH
        // ========================================================

        case "popupHadiah":
          this.showPopupReward(data.param.data.point);

          break;

        // ========================================================
        // POPUP TOKEN
        // ========================================================

        case "popupToken":
          this.showPopupValidateToken();

          break;

        // ========================================================
        // PLAYER APP DATA
        // ========================================================

        case "getPlayerAppData":
          this.getPlayerAppData().then(
            () => {
              const playerData = this.$store.state.playerData || {};

              const params = {
                success: true,

                data: {
                  ball: playerData.ball == null ? 0 : playerData.ball,

                  costume: playerData.costume == null ? 0 : playerData.costume,

                  lang: playerData.lang == null ? 0 : playerData.lang,
                },
              };

              this.accessMethodeGame("startPlayerAppData", params);
            },

            (error) => {
              this.statusRequest = 0;

              console.error("err", error);

              this.accessMethodeGame("startPlayerAppData", {
                success: true,

                data: {
                  ball: 0,

                  costume: 0,

                  lang: 0,
                },
              });
            },
          );

          break;

        // ========================================================
        // GET PROFILE
        // ========================================================

        case "getProfile":
          if (this.statusRequest == 0) {
            this.statusRequest = 1;

            this.getDetail().then(
              async () => {
                const dataPoint = this.$store.state.point;

                const dataLife = this.$store.state.coin;

                const dataTelco = this.$store.state.telco;

                const dataMSISDN = this.$store.state.user;

                const playerData = this.$store.state.playerData || {};

                let dataMaxpoint = 30;

                if (
                  dataTelco == "tsel" ||
                  dataTelco == "smart" ||
                  dataTelco == "cellcard"
                ) {
                  this.setReward(null);
                }

                this.statusRequest = 0;

                if (dataTelco == "tsel" || dataTelco == "cellcard") {
                  dataMaxpoint = 10;
                }

                const params = {
                  success: true,

                  data: JSON.stringify({
                    maxpoint: dataMaxpoint,

                    point: dataPoint,

                    life: dataLife,

                    msisdn: dataMSISDN,

                    dificult: 1,

                    avatar: null,

                    language:
                      playerData.language == null
                        ? playerData.lang
                        : playerData.language,

                    telco: {
                      mno_shortname: dataTelco,
                    },
                  }),

                  reward: this.reward,

                  type: 1,

                  options: {
                    title_value: "poin",

                    mode_game: "round",
                  },
                };

                this.$store.state.isLoading = false;

                this.accessMethodeGame("setProfile", params);
              },

              (error) => {
                this.statusRequest = 0;

                this.$store.state.isLoading = false;

                console.error("err", error);

                this.accessMethodeGame("setProfile", {
                  success: true,

                  data: JSON.stringify({
                    maxpoint: 30,

                    point: 0,

                    life: 0,

                    msisdn: this.$store.state.user,

                    dificult: 1,

                    avatar: null,

                    telco: {
                      mno_shortname: this.$store.state.telco,
                    },
                  }),

                  reward: null,

                  type: 1,

                  options: {
                    title_value: "poin",

                    mode_game: "round",
                  },
                });
              },
            );
          }

          break;

        // ========================================================
        // GET TOKEN LIFE
        // ========================================================

        case "getTokenLife":
          if (this.statusRequest == 0) {
            this.statusRequest = 1;

            if (this.telco != "cellcard") {
              this.getLife().then(
                () => {
                  const params = {
                    success: true,

                    data: {},
                  };

                  if (this.tokenLife === null || this.coin === 0) {
                    params.success = false;
                  }

                  this.accessMethodeGame("setTokenLife", params);

                  this.statusRequest = 0;
                },

                (error) => {
                  this.statusRequest = 0;

                  console.error("err", error);
                },
              );
            }

            if (this.telco == "cellcard") {
              this.getLifeSubs().then(
                (lifeId) => {
                  if (lifeId != "") {
                    this.getLife().then(
                      () => {
                        const params = {
                          success: true,

                          data: {},
                        };

                        if (lifeId === null) {
                          params.success = false;
                        }

                        this.accessMethodeGame("setTokenLife", params);

                        this.statusRequest = 0;
                      },

                      (error) => {
                        this.statusRequest = 0;

                        console.error("err", error);

                        this.showPopupValidateSubs();
                      },
                    );
                  }
                },

                (error) => {
                  this.statusRequest = 0;

                  console.error("err", error);

                  this.showPopupValidateSubs();
                },
              );
            }
          }

          break;

        // ========================================================
        // STORE POINT
        // ========================================================

        case "storePoint": {
          let dataPoint = data.param.data.point;

          let totalPoint = dataPoint[0].point.toString();

          if (this.mode !== "free") {
            this.storePoint(dataPoint).then(
              // this.storePointGo(dataPoint).then(
              () => {
                const params = {
                  success: true,

                  data: {},
                };

                this.showPopupReward(totalPoint);

                this.accessMethodeGame("statusStorePoint", params);
              },

              (error) => {
                console.error(error);

                const params = {
                  success: false,

                  data: {},
                };

                this.accessMethodeGame("statusStorePoint", params);
              },
            );
          } else {
            this.$store.commit("SET_POINT", parseInt(totalPoint));

            const params = {
              success: true,

              data: {},
            };

            this.showPopupReward(totalPoint);

            this.accessMethodeGame("statusStorePoint", params);
          }

          break;
        }

        // ========================================================
        // INFO
        // ========================================================

        case "getInfo":
          this.setPopupInfo();

          this.idPopup = "popupInfo";

          this.setPopupShow(true);

          break;

        // ========================================================
        // UPDATE PLAYER DATA
        // ========================================================

        case "updatePlayerAppData":
          this.setPlayerData(data.param.data.point).then(
            () => {
              const params = {
                success: true,

                data: {},
              };

              this.accessMethodeGame("setPlayerAppData", params);
            },

            (error) => {
              console.error(error);

              const params = {
                success: false,

                data: {},
              };

              this.accessMethodeGame("setPlayerAppData", params);
            },
          );

          break;

        // ========================================================
        // SERVICE
        // ========================================================

        case "getService":
          this.getService().then(
            () => {
              this.idPopup = "popupService";

              this.setPopupShow(true);
            },

            (error) => {
              this.statusRequest = 0;

              console.error("err", error);
            },
          );

          break;

        // ========================================================
        // LEADERBOARD
        // ========================================================

        case "getLeaderboard":
          this.getLeaderboard().then(
            () => {
              const params = {
                success: true,

                data: this.leaderboardList,
              };

              this.accessMethodeGame("setLeaderboard", params);
            },

            (error) => {
              this.statusRequest = 0;

              console.error("err", error);
            },
          );

          break;

        // ========================================================
        // GAME REQUEST FULLSCREEN
        // ========================================================

        case "goFullscreen":
          if (!this.isFullscreen && !deviceAndroid) {
            this.toggle();
          }

          break;

        case "logout":
          this.showPopupLogout();

          // this.$store.commit("SET_USER", null);
          // this.$store.commit("SET_PRE_USER", null);

          // this.$router.push({ name: "login" });
          break;
      }
    };

    window.addEventListener("message", this.messageHandler);

    // ============================================================
    // NATIVE FULLSCREEN EVENT
    // ============================================================

    this.fullscreenChangeHandler = this.fullscreenchanged.bind(this);

    document.addEventListener("fullscreenchange", this.fullscreenChangeHandler);

    document.addEventListener(
      "webkitfullscreenchange",
      this.fullscreenChangeHandler,
    );
  },

  beforeDestroy() {
    // ============================================================
    // CLEAR TIMER
    // ============================================================

    if (this.iframeCheckTimer) {
      clearTimeout(this.iframeCheckTimer);

      this.iframeCheckTimer = null;
    }

    // ============================================================
    // REMOVE MESSAGE EVENT
    // ============================================================

    window.removeEventListener("message", this.messageHandler);

    // ============================================================
    // REMOVE FULLSCREEN EVENTS
    // ============================================================

    document.removeEventListener(
      "fullscreenchange",
      this.fullscreenChangeHandler,
    );

    document.removeEventListener(
      "webkitfullscreenchange",
      this.fullscreenChangeHandler,
    );

    // ============================================================
    // CLEANUP FAKE FULLSCREEN
    // ============================================================

    this.exitForcedFullscreen();

    // ============================================================
    // DISCONNECT WEBSOCKET
    // ============================================================

    this.disconnectSessionSocket();
  },

  methods: {
    ...mapActions([
      "getProfile",

      "getDetail",

      "getLife",

      "storePoint",

      "storePointGo",

      "setPlayerData",

      "getGameReward",

      "getGames",

      "deliverRecipe",

      "getDR",

      "getPlayerAppData",

      "getService",

      "getLeaderboard",

      "getLifeSubs",
    ]),

    ...mapMutations({
      setReward: "SET_REWARD",

      setPopupShow: "SET_GAME_POPUP_SHOW",
    }),

    // ============================================================
    // FULLSCREEN TOGGLE
    // ============================================================

    async toggle() {
      try {
        // ========================================================
        // iOS
        // ========================================================

        if (this.isIOS) {
          if (this.forcedFullscreen) {
            this.exitForcedFullscreen();
          } else {
            this.forceIframeFullscreen();
          }

          return;
        }

        // ========================================================
        // NATIVE FULLSCREEN IS ACTIVE
        // ========================================================

        if (getFullscreenElement()) {
          await exitBrowserFullscreen();

          this.fullscreen = false;

          return;
        }

        // ========================================================
        // CONTAINER
        // ========================================================

        const container = this.$el.querySelector("#fullscreen-div");

        if (!container) {
          console.warn("Fullscreen container not found");

          return;
        }

        // ========================================================
        // NATIVE FULLSCREEN
        // ========================================================

        try {
          await requestBrowserFullscreen(container);

          this.fullscreen = true;
        } catch (error) {
          // ========================================================
          // FALLBACK
          // ========================================================

          console.warn("Native fullscreen failed. Using CSS fallback.", error);

          this.forceIframeFullscreen();
        }
      } catch (error) {
        console.warn("Fullscreen error:", error);
      }
    },

    // ============================================================
    // NATIVE FULLSCREEN EVENT
    // ============================================================

    fullscreenchanged() {
      this.fullscreen = !!getFullscreenElement();
    },

    // ============================================================
    // FORCE / FAKE FULLSCREEN
    // ============================================================

    forceIframeFullscreen() {
      const el = this.$el.querySelector("#fullscreen-div");

      if (!el) {
        console.warn("Fullscreen container not found");

        return;
      }

      if (this.forcedFullscreen) {
        return;
      }

      // ----------------------------------------------------------
      // Add fullscreen class
      // ----------------------------------------------------------

      el.classList.add("is-fullscreen");

      // ----------------------------------------------------------
      // Lock document
      // ----------------------------------------------------------

      document.documentElement.classList.add("fullscreen-lock");

      document.body.classList.add("fullscreen-lock");

      // ----------------------------------------------------------
      // State
      // ----------------------------------------------------------

      this.forcedFullscreen = true;

      // ----------------------------------------------------------
      // Force browser resize
      // ----------------------------------------------------------

      this.$nextTick(() => {
        window.dispatchEvent(new Event("resize"));
      });
    },

    // ============================================================
    // EXIT FAKE FULLSCREEN
    // ============================================================

    exitForcedFullscreen() {
      const el = this.$el.querySelector("#fullscreen-div");

      if (el) {
        el.classList.remove("is-fullscreen");
      }

      document.documentElement.classList.remove("fullscreen-lock");

      document.body.classList.remove("fullscreen-lock");

      this.forcedFullscreen = false;

      this.$nextTick(() => {
        window.dispatchEvent(new Event("resize"));
      });
    },

    // ============================================================
    // SET URL
    // ============================================================

    setUrl(url) {
      if (!url || typeof url !== "string") {
        return "#";
      }

      const sUrl = url.replace(/^http:\/\//i, "https://");

      return `${sUrl}?msisdn=${this.$store.state.user}`;
    },

    // ============================================================
    // POPUP TOKEN
    // ============================================================

    showPopupValidateToken() {
      this.idPopup = "popupToken";

      this.setPopupShow(true);

      this.setPopupToken();
    },

    // ============================================================
    // POPUP LOGOUT
    // ============================================================
    showPopupLogout() {
      this.idPopup = "popupLogout";

      this.setPopupShow(true);

      this.setPopupLogout();
    },

    // ============================================================
    // POPUP SUBSCRIPTION
    // ============================================================

    showPopupValidateSubs() {
      // this.idPopup = "emptySubscription";

      // this.setPopupShow(true);

      // this.setPopupSubs();
      this.$store.commit("SET_PRE_USER", null);
      this.$router.push({ name: "subscribe" });
    },

    // ============================================================
    // POPUP REWARD
    // ============================================================

    showPopupReward(point) {
      this.setPopupReward(point);
    },

    // ============================================================
    // SET POPUP TOKEN
    // ============================================================

    setPopupToken() {
      const token = this.popupToken;

      this.datapopup.image = token.image;

      this.datapopup.title = token.title;

      this.datapopup.description = token.description;

      this.datapopup.txtButton = "Tambah Token";
    },

    setPopupLogout() {
      const token = this.popupLogout || {};

      let playerLang = localStorage.getItem("loginLanguage");

      if (!playerLang) {
        playerLang = "km";
      }

      this.datapopup.image = token.image || null;

      const title =
        token.title && typeof token.title === "object"
          ? token.title[playerLang]
          : token.title;

      const description =
        token.description && typeof token.description === "object"
          ? token.description[playerLang]
          : token.description;

      const button =
        token.button && typeof token.button === "object"
          ? token.button[playerLang]
          : token.button;

      const buttonCancel =
        token.button && typeof token.buttonCancel === "object"
          ? token.buttonCancel[playerLang]
          : token.buttonCancel;

      this.datapopup.title = title || null;

      this.datapopup.description = description || null;

      this.datapopup.txtButton = button || null;
      this.datapopup.buttonCancel = buttonCancel || null;
    },

    // ============================================================
    // SET POPUP SUBS
    // ============================================================

    setPopupSubs() {
      const token = this.popupSubscription || {};

      let playerLang = localStorage.getItem("loginLanguage");

      if (!playerLang) {
        playerLang = "km";
      }

      this.datapopup.image = token.image || null;

      const title =
        token.title && typeof token.title === "object"
          ? token.title[playerLang]
          : token.title;

      const description =
        token.description && typeof token.description === "object"
          ? token.description[playerLang]
          : token.description;

      const button =
        token.button && typeof token.button === "object"
          ? token.button[playerLang]
          : token.button;

      this.datapopup.title = title || null;

      this.datapopup.description = description || null;

      this.datapopup.txtButton = button || null;
    },

    setPopupInfo() {
      const token = this.popupSubscription || {};

      // let playerLang = localStorage.getItem("loginLanguage");
      let playerLang = this.$store.state.playerData.lang;

      if (!playerLang) {
        playerLang = "km";
      }

      this.datapopup.image = token.image || null;

      const title =
        token.title && typeof token.title === "object"
          ? token.title[playerLang]
          : token.title;

      const description =
        token.description && typeof token.description === "object"
          ? token.description[playerLang]
          : token.description;

      const button =
        token.buttonOk && typeof token.buttonOk === "object"
          ? token.buttonOk[playerLang]
          : token.buttonOk;

      this.datapopup.title = title || null;

      this.datapopup.description = description || null;

      this.datapopup.txtButton = button || "Ok";
    },

    // ============================================================
    // SET REWARD
    // ============================================================

    setPopupReward(point) {
      const index = this.popupReward.findIndex((item) => item.point === point);

      if (index !== -1) {
        this.idPopup = "popupReward";

        this.setPopupShow(true);

        const rewards = this.popupReward[index];

        this.datapopup.image = rewards.image;

        this.datapopup.title = rewards.title;

        this.datapopup.description = rewards.description;

        this.datapopup.txtButton = "Ambil";
      }
    },

    // ============================================================
    // DELIVER RECHIVES
    // ============================================================

    getdeliverRechives(id) {
      let date = new Date();

      let dates =
        ("00" + (date.getMonth() + 1)).slice(-2) +
        "/" +
        ("00" + date.getDate()).slice(-2) +
        "/" +
        date.getFullYear() +
        " " +
        ("00" + date.getHours()).slice(-2) +
        ":" +
        ("00" + date.getMinutes()).slice(-2) +
        ":" +
        ("00" + date.getSeconds()).slice(-2);

      const data = {
        date: dates,

        marketid: id,

        msisdn: this.user,
      };

      this.deliverRecipe(data).then(
        () => {
          const res = this.dr;

          if (res == "success") {
            this.$router.go(0);
          }
        },

        (error) => {
          alert("Error: " + error);
        },
      );
    },

    // ============================================================
    // SEND MESSAGE TO GAME
    // ============================================================

    accessMethodeGame(command, params) {
      if (!this.iframeGame) {
        return;
      }

      this.iframeGame.postMessage(
        {
          cmd: command,

          param: params,
        },

        "*",
      );
    },

    // ============================================================
    // OPEN GAME NEW TAB
    // ============================================================

    openInNewTab() {
      const href = this.urls || this.setUrl(this.url) || "#";

      if (href && href !== "#") {
        window.open(href, "_blank");
      }
    },

    // ============================================================
    // RETRY IFRAME
    // ============================================================

    retryIframe() {
      this.iframeFailed = false;

      this.iframeReady = false;

      this.urls = this.setUrl(this.url);

      if (this.iframeCheckTimer) {
        clearTimeout(this.iframeCheckTimer);
      }

      this.iframeCheckTimer = setTimeout(() => {
        if (!this.iframeReady) {
          this.iframeFailed = true;
        }

        this.iframeCheckTimer = null;
      }, 5000);
    },

    updatePoin() {
      // intentionally empty
    },

    // ============================================================
    // SESSION WEBSOCKET (reconnect when user returns to /play)
    // ============================================================

    connectSessionSocket(sessionId, attempt = 0) {
      if (!sessionId || typeof WebSocket === "undefined") return;

      const INITIAL_TIMEOUT_MS = 10000;
      const MAX_RECONNECT_DELAY_MS = 30000;

      try {
        const baseUrl = (
          process.env.VUE_APP_API_BASE_URL_GO ||
          process.env.VUE_APP_API_GO ||
          ""
        ).replace(/\/$/, "");
        const wsBaseUrl = baseUrl.replace(/^http/, "ws");
        const wsUrl = `${wsBaseUrl}/sessions/ws?session_id=${encodeURIComponent(
          sessionId,
        )}`;

        if (attempt === 0) this.disconnectSessionSocket();
        this.ws = new WebSocket(wsUrl);

        let openTimeout = null;
        let socketDidOpen = false;

        const clearOpenTimeout = () => {
          if (openTimeout) {
            clearTimeout(openTimeout);
            openTimeout = null;
          }
        };

        const scheduleReconnect = (delay) => {
          clearOpenTimeout();
          this.reconnectTimer = setTimeout(() => {
            this.connectSessionSocket(sessionId, attempt + 1);
          }, delay);
        };

        openTimeout = setTimeout(() => {
          this.sendErrorLog({
            source: "Play",
            action: "websocketConnectionTimeout",
            message: "WebSocket did not open within timeout",
            sessionId: sessionId || null,
            attempt: attempt,
            wsUrl: wsUrl || null,
            route: (this.$route && this.$route.name) || null,
            ua:
              (typeof navigator !== "undefined" && navigator.userAgent) || null,
            timestamp: new Date().toISOString(),
          });
          try {
            this.ws.close();
          } catch (e) {
            // ignore
          }
          this.ws = null;
          scheduleReconnect(
            Math.min(2000 * Math.pow(2, attempt), MAX_RECONNECT_DELAY_MS),
          );
        }, INITIAL_TIMEOUT_MS);

        this.ws.onopen = () => {
          clearOpenTimeout();
          socketDidOpen = true;
          console.log("Session websocket connected from /play");
        };

        this.ws.onmessage = (event) => {
          try {
            const message = JSON.parse(event.data || "{}");
            console.log(message);
            if (
              message.type === "force_logout" ||
              message.reason === "login_new_device"
            ) {
              this.handleForceLogout(
                message.message ||
                  "You have been logged out because your account logged in from a new device.",
              );
            }
          } catch (e) {
            console.warn("Failed to parse websocket message", e);
            this.sendErrorLog({
              source: "Play",
              action: "websocketMessageParse",
              message: e && e.message ? e.message : String(e),
              stack: e && e.stack ? e.stack : null,
              sessionId: sessionId || null,
              route: (this.$route && this.$route.name) || null,
              ua:
                (typeof navigator !== "undefined" && navigator.userAgent) ||
                null,
              timestamp: new Date().toISOString(),
            });
          }
        };

        this.ws.onerror = (error) => {
          clearOpenTimeout();
          console.warn("Session websocket error", error);
          this.sendErrorLog({
            source: "Play",
            action: "websocketError",
            message: "WebSocket error event fired",
            sessionId: sessionId || null,
            attempt: attempt,
            wsUrl: wsUrl || null,
            route: (this.$route && this.$route.name) || null,
            ua:
              (typeof navigator !== "undefined" && navigator.userAgent) || null,
            timestamp: new Date().toISOString(),
          });
        };

        this.ws.onclose = (event) => {
          clearOpenTimeout();
          this.ws = null;
          // Keep reconnecting silently on disconnect/close. The server will
          // send a force_logout message if another device takes over.
          if (!socketDidOpen || !event.wasClean) {
            scheduleReconnect(
              Math.min(2000 * Math.pow(2, attempt), MAX_RECONNECT_DELAY_MS),
            );
          }
        };
      } catch (e) {
        console.warn("Failed to connect session websocket", e);
        this.sendErrorLog({
          source: "Play",
          action: "websocketConnectException",
          message: e && e.message ? e.message : String(e),
          stack: e && e.stack ? e.stack : null,
          sessionId: sessionId || null,
          attempt: attempt,
          route: (this.$route && this.$route.name) || null,
          ua:
            (typeof navigator !== "undefined" && navigator.userAgent) || null,
          timestamp: new Date().toISOString(),
        });
        setTimeout(() => {
          this.connectSessionSocket(sessionId, attempt + 1);
        }, Math.min(2000 * Math.pow(2, attempt), MAX_RECONNECT_DELAY_MS));
      }
    },

    disconnectSessionSocket() {
      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
      }
      if (this.ws) {
        try {
          this.ws.close();
        } catch (e) {
          // ignore
        }
        this.ws = null;
      }
    },

    handleForceLogout(message) {
      this.disconnectSessionSocket();
      this.$store.commit("SET_SESSION_USER", null);
      this.$store.commit("SET_USER", null);
      this.$store.commit("SET_PRE_USER", null);
      this.errorMessage = message || "Your session has been logged out.";
      this.$router.push({ name: "login" }).catch(() => {});
    },

    async sendErrorLog(payload) {
      if (!payload) return;
      try {
        await apiMsg.post("a/fe", { type: "frontend_error", payload });
      } catch (e) {
        try {
          const fallbackPayload = {
            level: "error",
            message: payload.message || payload.action || "frontend_error",
            url:
              window.location.href ||
              (this.$route && this.$route.fullPath) ||
              null,
            stack: payload.stack || JSON.stringify(payload),
            extra: payload,
          };
          await apiMsg.post("a/fe", fallbackPayload);
        } catch (fallbackError) {
          console.warn("sendErrorLog failed", fallbackError, payload);
        }
      }
    },
  },
};
</script>

<!-- =============================================================
     GLOBAL STYLE
     JANGAN SCOPED
     ============================================================= -->

<style>
html.fullscreen-lock,
body.fullscreen-lock {
  width: 100% !important;

  height: 100% !important;

  margin: 0 !important;

  padding: 0 !important;

  overflow: hidden !important;

  overscroll-behavior: none !important;
}

/*
 * iOS Safari
 *
 * Hilangkan kemungkinan scroll horizontal
 */

html.fullscreen-lock {
  overflow-x: hidden !important;

  overflow-y: hidden !important;
}

body.fullscreen-lock {
  position: fixed !important;

  left: 0 !important;

  top: 0 !important;

  right: 0 !important;

  bottom: 0 !important;
}
</style>

<style scoped>
/* ===============================================================
   MAIN
   =============================================================== */

.play-screen {
  width: 100%;

  min-width: 100%;

  min-height: 100dvh;

  margin: 0;

  padding: 0;

  overflow: hidden;
}

.play-screen__row {
  width: 100%;

  min-width: 100%;

  min-height: 100dvh;

  margin-left: 0 !important;

  margin-right: 0 !important;
}

.play-screen__row > .col {
  padding-left: 0 !important;

  padding-right: 0 !important;
}

/* ===============================================================
   FULLSCREEN CONTAINER
   =============================================================== */

#fullscreen-div {
  position: relative;

  width: 100%;

  height: 100dvh;

  min-height: 100dvh;

  min-width: 100%;

  margin: 0 !important;

  padding: 0 !important;

  overflow: hidden;

  background: #000;
}

/* ===============================================================
   IFRAME
   =============================================================== */

.display-frame {
  display: block !important;

  position: absolute !important;

  top: 0 !important;

  left: 0 !important;

  width: 100% !important;

  height: 100% !important;

  min-width: 100% !important;

  min-height: 100% !important;

  max-width: none !important;

  max-height: none !important;

  margin: 0 !important;

  padding: 0 !important;

  border: 0 !important;

  background: #000;
}

/* ===============================================================
   FAKE FULLSCREEN
   =============================================================== */

#fullscreen-div.is-fullscreen {
  position: fixed !important;

  top: 0 !important;

  left: 0 !important;

  right: 0 !important;

  bottom: 0 !important;

  width: 100vw !important;

  width: 100dvw !important;

  height: 100vh !important;

  height: 100dvh !important;

  min-width: 100vw !important;

  min-width: 100dvw !important;

  min-height: 100vh !important;

  min-height: 100dvh !important;

  max-width: none !important;

  max-height: none !important;

  margin: 0 !important;

  padding: 0 !important;

  overflow: hidden !important;

  background: #000 !important;

  z-index: 2147483646 !important;
}

/* ===============================================================
   FULLSCREEN IFRAME
   =============================================================== */

#fullscreen-div.is-fullscreen .display-frame {
  position: absolute !important;

  top: 0 !important;

  left: 0 !important;

  right: 0 !important;

  bottom: 0 !important;

  width: 100vw !important;

  width: 100dvw !important;

  height: 100vh !important;

  height: 100dvh !important;

  min-width: 100vw !important;

  min-width: 100dvw !important;

  min-height: 100vh !important;

  min-height: 100dvh !important;

  max-width: none !important;

  max-height: none !important;

  margin: 0 !important;

  padding: 0 !important;

  border: 0 !important;

  transform: none !important;
}

/* ===============================================================
   FULLSCREEN BUTTON
   =============================================================== */

.fullscreen-button-wrapper {
  position: fixed !important;

  left: 16px !important;
  right: auto !important;

  bottom: calc(16px + env(safe-area-inset-bottom, 0px));

  z-index: 2147483647 !important;

  padding-left: env(safe-area-inset-left, 0px);

  padding-right: 0;
}

/* ===============================================================
   BUTTON
   =============================================================== */

.custom-btn,
.custom-btn:hover,
.custom-btn:active,
.custom-btn:focus {
  padding: 0 !important;

  border: none !important;

  outline: none !important;

  background-color: #000000c2 !important;

  width: 50px;

  height: 50px;

  border-radius: 25px;

  box-shadow: none !important;
}

/* ===============================================================
   FALLBACK
   =============================================================== */

.iframe-fallback {
  position: absolute;

  inset: 0;

  display: flex;

  align-items: center;

  justify-content: center;

  z-index: 2000;
}

.fallback-box {
  background: rgba(0, 0, 0, 0.8);

  border-radius: 8px;

  padding: 1.2rem;

  color: #fff;

  text-align: center;
}

.fallback-box .btns b-button {
  margin: 0.4rem;
}

/* ===============================================================
   MODAL
   =============================================================== */

.modal-footer button {
  display: block;

  width: 100%;

  color: #f8f9fa !important;

  border-radius: 20px;

  background: linear-gradient(90deg, #ff4401 0%, #ff0077 57.29%);
}

/* ===============================================================
   CELL CARD PORTRAIT → LANDSCAPE ROTATION
   Host app top/bottom nav heights can be overridden via:
   :root { --cellcard-top-nav-height: XXpx; --cellcard-bottom-nav-height: YYpx; }
   =============================================================== */

.display-frame--landscape {
  position: fixed !important;

  top: 50% !important;

  left: 50% !important;

  width: calc(
    100vh - var(--cellcard-top-nav-height, 56px) -
      var(--cellcard-bottom-nav-height, 56px)
  ) !important;

  height: 100vw !important;

  min-width: calc(
    100vh - var(--cellcard-top-nav-height, 56px) -
      var(--cellcard-bottom-nav-height, 56px)
  ) !important;

  min-height: 100vw !important;

  margin-top: calc(
    (
        var(--cellcard-top-nav-height, 60px) -
          var(--cellcard-bottom-nav-height, 60px)
      ) / 2
  ) !important;

  margin-bottom: calc(
    (
        var(--cellcard-bottom-nav-height, 60px) -
          var(--cellcard-top-nav-height, 60px)
      ) / 2
  ) !important;

  transform: translate(-50%, -50%) rotate(90deg) !important;

  transform-origin: center center !important;
}

/* ===============================================================
   GAME BACKGROUND (visible behind iframe when cellcardFramePotrait)
   =============================================================== */

#fullscreen-div.has-game-bg {
  background-image: url("~@/assets/bg_games.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

/* ===============================================================
   LANDSCAPE
   =============================================================== */

@media (orientation: landscape) {
  .modal-dialog {
    width: 50vh !important;

    margin: 0 auto !important;
  }

  .modal-body {
    padding-bottom: 0 !important;
  }

  .txt-desc {
    font-size: 0.8rem;
  }
}

/* ===============================================================
   PORTRAIT
   =============================================================== */

@media (orientation: portrait) {
  .modal-dialog {
    width: 50vw !important;

    margin: 0 auto !important;
  }

  .txt-desc {
    font-size: 0.8rem;
  }
}

/* ===============================================================
   IPAD / TABLET
   =============================================================== */

@media (min-width: 768px) and (max-width: 1366px) {
  .fullscreen-button-wrapper {
    left: auto;

    right: 16px;

    bottom: 16px;

    padding-right: env(safe-area-inset-right, 0px);

    padding-left: 0;

    padding-bottom: env(safe-area-inset-bottom, 0px);
  }

  .custom-btn,
  .custom-btn:hover,
  .custom-btn:active,
  .custom-btn:focus {
    width: 56px;

    height: 56px;

    border-radius: 28px;
  }
}

/* ===============================================================
   IPAD PORTRAIT
   =============================================================== */

@media (min-width: 768px) and (max-width: 1366px) and (orientation: portrait) {
  .modal-dialog {
    width: min(70vw, 560px) !important;

    max-width: 560px !important;
  }

  .txt-desc {
    font-size: 1rem;
  }
}

/* ===============================================================
   IPAD LANDSCAPE
   =============================================================== */

@media (min-width: 768px) and (max-width: 1366px) and (orientation: landscape) {
  .modal-dialog {
    width: min(55vh, 560px) !important;

    max-width: 560px !important;
  }

  .txt-desc {
    font-size: 0.9rem;
  }
}

/* ===============================================================
   IOS
   =============================================================== */

@supports (-webkit-touch-callout: none) {
  #fullscreen-div.is-fullscreen {
    width: 100vw !important;

    height: 100vh !important;

    height: 100dvh !important;

    overflow: hidden !important;
  }

  #fullscreen-div.is-fullscreen .display-frame {
    width: 100vw !important;

    height: 100vh !important;

    height: 100dvh !important;
  }
}
</style>
